import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "react-jss";
import { Provider } from "react-redux";

import { enforceDisabledAuthStartupState } from "@/api/authSession";
import Loader from "@/base/components/Global/Loader";
import { store } from "@/store";
import { getBrandTheme } from "@/theme";
import { GlobalStyleProvider } from "@/theme/GlobalStyleProvider";

import App from "./App";

import "modern-normalize";
import "./sentry";
import "./translation";

enforceDisabledAuthStartupState();

createRoot(document.querySelector("#root")!).render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={getBrandTheme() || {}}>
        <GlobalStyleProvider>
          <Suspense fallback={<Loader isFullScreen />}>
            <App />
          </Suspense>
        </GlobalStyleProvider>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>,
);
